/**
 * As 4 tools de front, num lugar só ([T015] / US-4).
 *
 * Espelho de `aawz_intelligence_v2/tools/tools_de_front.py`: lá o modelo lê o
 * que elas fazem, aqui o browser as executa. Quem as liga ao `UI_REGISTRY` é
 * `ui-registry/plataforma.js`.
 *
 * ★ Aqui também é onde os formulários de MODAL do `preencher` entram no ar
 *   ([T019]). Este arquivo é carregado por `plataforma.js`, que por sua vez só
 *   é carregado no BOOT (`modules/aawz-intelligence-v2/index.js`) — fora do
 *   grafo do `apiChat`, que é o que mantém o catálogo de navegação longe do
 *   ciclo de imports que derrubou 8 suítes em 26/08. O formulário do Fee Fixo
 *   não vem por aqui: quem o registra é o módulo DONO dele, no boot
 *   (`modules/fee-fixo/index.js`).
 */
import navegar from './navegar'
import abrirCliente from './abrir-cliente'
import preencher from './preencher'
import destacar from './destacar'
import { registrarFormulariosGlobalBus } from './formularios-globalbus'

registrarFormulariosGlobalBus()

export const TOOLS_DE_FRONT = [navegar, abrirCliente, preencher, destacar]

export default TOOLS_DE_FRONT
